export default __webpack_public_path__ + "static/media/file-logo.275fa769.jpg";